import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeAlphaCapital';
const args = {};

export class ModeAlphaCapital extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
